module.exports = __webpack_public_path__ + "static/img/mediaGalleryImg.91261c3.png";